//#region import libraries
import React, { useEffect } from 'react';

// custom components
import { CustomSpinner, Container } from '_atoms';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectEditBooking } from '_redux/slices/assistance-bookings/booking-requests-table'
import { selectProfileBubble, selectProfileBubbleStatus, getFirebaseInfo } from '_redux/slices/main-screen/user';

// bootstrap
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';

// placeholder
import placeholder from "_assets/images/profile/placeholder.jpeg";
//#endregion

const ProfilePicture = (props) => {
    return (
        <Image
            src={props.user && props.user.photoURL ? props.user.photoURL : placeholder}
            height={'auto'}
            width={100}
            style={{ borderRadius: 25 }}
        />
    )
}

const ProfileBubble = (props) => {

    //#region redux
    const dispatch = useDispatch();
    const selectedBooking = useSelector(selectEditBooking)
    const fetchStatus = useSelector(selectProfileBubbleStatus)
    const user = useSelector(selectProfileBubble);
    //#endregion

    // get firebase info on render
    useEffect(() => {
        if (props.user) {
            dispatch(getFirebaseInfo(props.user))
        }
        else if (selectedBooking && selectedBooking.userId && selectedBooking.userId !== "SITA") {
            // get profile information from firebase
            dispatch(getFirebaseInfo(selectedBooking.userId))
        }

    }, [selectedBooking]);

    return (
        <Container>
            {
                fetchStatus == 'loading' ?
                    <Row style={{ marginLeft: 100 }} className='mt-2'>
                        <CustomSpinner />
                    </Row>
                    :
                    fetchStatus == 'succeeded' ?
                        <div style={{ display: 'flex' }}>

                            {/* Profile Picture */}
                            <ProfilePicture user={user} />

                            {/* Name and Email */}
                            <Container>
                                <p style={{ fontSize: 16, marginTop: 32 }}>{user && user.displayName ? user.displayName : selectedBooking.name}</p>
                                <p style={{ fontSize: 18, opacity: 0.7, marginTop: -12 }}>{user && user.email ? user.email : 'Email not provided'}</p>
                            </Container>
                        </div>
                        :
                        <></>
            }
        </Container>
    );
};

export default ProfileBubble;